export const LOCATIONS = [
  "Antalya Havalimanı",
  "Antalya Merkez",
  "Lara",
  "Kundu",
  "Belek",
  "Boğazkent",
  "Side",
  "Sorgun",
  "Çolaklı",
  "Manavgat",
  "Kumköy",
  "Evrenseki",
  "Gündoğdu",
  "Titreyengöl",
  "Kızılot",
  "Kızılağaç",
  "Okurcalar",
  "Avsallar",
  "İncekum",
  "Alanya",
  "Konaklı",
  "Türkler",
  "Mahmutlar",
  "Kestel",
  "Göynük",
  "Kemer",
  "Beldibi",
  "Konyaaltı",
  "Kaleiçi",
  "Tekirova",
  "Kiriş",
  "Çamyuva",
  "Kaş",
  "Kalkan",
  "Fethiye",
  "Marmaris",
  "Bodrum",
  "Isparta",
  "Burdur",
  "Pamukkale"
];

// Prices updated based on user image + ~10 USD (360 TL) margin
// Base Euro Rate assumption: 38 TL
export const INITIAL_ROUTES = [
  { from: "Antalya Havalimanı", to: "Antalya Merkez", price: 1150 }, // ~20€ + 10$
  { from: "Antalya Havalimanı", to: "Lara", price: 1150 }, // Same as Kundu
  { from: "Antalya Havalimanı", to: "Kundu", price: 1150 }, // 20€ -> 760 + 360
  { from: "Antalya Havalimanı", to: "Belek", price: 1350 }, // 25€ -> 950 + 360
  { from: "Antalya Havalimanı", to: "Boğazkent", price: 1550 }, // 30€ -> 1140 + 360
  { from: "Antalya Havalimanı", to: "Side", price: 1700 }, // 35€ -> 1330 + 360
  { from: "Antalya Havalimanı", to: "Sorgun", price: 1850 }, // 38€ -> 1444 + 360
  { from: "Antalya Havalimanı", to: "Çolaklı", price: 1700 }, // Grouped with Side
  { from: "Antalya Havalimanı", to: "Manavgat", price: 1700 }, // Grouped with Side
  { from: "Antalya Havalimanı", to: "Kumköy", price: 1700 }, // Grouped with Side
  { from: "Antalya Havalimanı", to: "Evrenseki", price: 1700 },
  { from: "Antalya Havalimanı", to: "Gündoğdu", price: 1700 },
  { from: "Antalya Havalimanı", to: "Titreyengöl", price: 1850 }, // 38€
  { from: "Antalya Havalimanı", to: "Kızılot", price: 2100 }, // 45€ -> 1710 + 360
  { from: "Antalya Havalimanı", to: "Kızılağaç", price: 2100 }, // 45€
  { from: "Antalya Havalimanı", to: "Okurcalar", price: 2300 }, // 50€ -> 1900 + 360
  { from: "Antalya Havalimanı", to: "Avsallar", price: 2500 }, // 55€ -> 2090 + 360
  { from: "Antalya Havalimanı", to: "İncekum", price: 2500 }, // Grouped with Avsallar
  { from: "Antalya Havalimanı", to: "Türkler", price: 2500 }, // 55€
  { from: "Antalya Havalimanı", to: "Konaklı", price: 2500 }, // 55€
  { from: "Antalya Havalimanı", to: "Alanya", price: 2700 }, // 60€ -> 2280 + 360
  { from: "Antalya Havalimanı", to: "Mahmutlar", price: 2900 }, // 65€ -> 2470 + 360
  { from: "Antalya Havalimanı", to: "Kestel", price: 2900 }, // Grouped with Mahmutlar
  { from: "Antalya Havalimanı", to: "Beldibi", price: 1700 }, // 35€
  { from: "Antalya Havalimanı", to: "Göynük", price: 1900 }, // 40€ -> 1520 + 360
  { from: "Antalya Havalimanı", to: "Kemer", price: 1900 }, // 40€
  { from: "Antalya Havalimanı", to: "Kiriş", price: 2000 }, // 42€ -> 1596 + 360
  { from: "Antalya Havalimanı", to: "Çamyuva", price: 2000 }, // 42€
  { from: "Antalya Havalimanı", to: "Tekirova", price: 2100 }, // 45€
  { from: "Antalya Havalimanı", to: "Kaş", price: 6850 }, // Old + 350
  { from: "Antalya Havalimanı", to: "Fethiye", price: 7850 }, // Old + 350
  { from: "Antalya Havalimanı", to: "Konyaaltı", price: 1150 }, // Center
  { from: "Antalya Havalimanı", to: "Kaleiçi", price: 1150 }, // Center
];

// Updated with User's Uploaded Images (Round 2)
export const VEHICLES = [
  {
    id: 1,
    name: "Mercedes Vito VIP",
    type: "VIP Minivan",
    capacity: "6 Kişilik",
    // Image 1
    image: "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/rmcrsdg9_WhatsApp%20Image%2020sdds26-01-dsd17%20at%2023.59.44.jpeg",
    features: ["Deri Koltuk", "Buzdolabı", "TV / Multimedya", "Ücretsiz WiFi", "Klima"],
  },
  {
    id: 2,
    name: "Mercedes Maybach",
    type: "Ultra Lüks Sedan",
    capacity: "3 Kişilik",
    // Image 2
    image: "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/omjup2mg_WhatsApp%20Image%202026-01asdfasd-17%20at%2023.59.44.jpeg",
    features: ["Masajlı Koltuk", "Özel Şoför", "Buzdolabı", "Multimedya", "Konfor"],
  },
  {
    id: 3,
    name: "Mercedes Sprinter VIP",
    type: "VIP Minibüs",
    capacity: "13 Kişilik",
    // Image 3
    image: "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/4hgjbq6v_WhatsApp%20Image%202026-asdfasd01-17%20at%2023.59.44.jpeg",
    features: ["Geniş Bagaj", "Deri Koltuk", "TV", "Buzdolabı", "Grup Transfer"],
  }
];

export const HERO_BG = "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/ma51rjxz_WhatsApp%20Image%202026-01-17%20atasdfasd23.59.45.jpeg";

export const GALLERY_IMAGES = [
    "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/vhiecf9i_WhatsApp%20Image%202026-01-17%20at%2023.59.40.jpeg",
    "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/isummbup_WhatsApp%20Image%202026-01-17%20sassat%2023.59.42.jpeg",
    "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/qz0daqsb_WhatsApp%20Image%202026-01-17%20at%2023.59.4110.jpeg",
    "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/ek17fs12_WhatsApp%20Image%202026asdfasd-01-17%20at%2023.59.46.jpeg",
    "https://customer-assets.emergentagent.com/job_vip-transport-8/artifacts/zz0sb3hs_WhatsApp%20Image%202026asdfasd-01-17%20at%2023.59.45.jpeg"
];
